import React from "react";
import styles from "../SpreadsheetGrid.module.scss";
import { BaseCellProps } from "./index";

export const StringCell: React.FC<BaseCellProps<string>> = ({
    value,
    onChange,
    isEditing,
    onBlur,
    inputRef,
}) => {
    if (isEditing) {
        return (
            <input
                type="text"
                className={styles.input}
                value={value ?? ""}
                ref={inputRef}
                onMouseDown={(e) => e.stopPropagation()}
                onChange={(e) => onChange(e.target.value)}
                onBlur={onBlur}
            />
        );
    }

    return <div>{value ?? ""}</div>;
};
